import { message, PageHeader, Spin, Upload, Row, Col, Tag, Tooltip } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Form, FormItem, TableItem, ButtonItem } from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";

class ImportarControlInventario extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    archivosExcel: [],
    data: [],
    archivoError: null,
    todasInsumos: [],
    todasProyectos: [],
  };

  componentDidMount() {
    this.setState({ loading: true });
    Promise.all([
      axios.post(
        "controlInventario/datosParaImportarControles",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
    ]).then(([res]) => {
      if (res.data.success === 2) {
        this.setState({
          todasInsumos: res.data.insumos,
          todasProyectos: res.data.proyectos,
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }
    });
  }

  atras() {
    this.props.history.goBack();
  }

  descargarPlantilla() {
    const wb = XLSX.utils.book_new();

    // Hoja principal vacía con encabezados
    const mainSheet = XLSX.utils.aoa_to_sheet([
      ["Clave", "Descripcion", "Proyecto", "Min", "Max"],
    ]);
    XLSX.utils.book_append_sheet(wb, mainSheet, "Controles");

    // Hoja de referencia: Insumos
    const insumosData = this.state.todasInsumos.map((i) => ({
      Clave: i.clave,
      Descripcion: i.descripcion,
    }));
    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(insumosData.length ? insumosData : [{ Clave: "", Descripcion: "" }]),
      "Insumos"
    );

    // Hoja de referencia: Proyectos
    const proyectosData = this.state.todasProyectos.map((p) => ({
      Proyecto: p.nombre,
    }));
    XLSX.utils.book_append_sheet(
      wb,
      XLSX.utils.json_to_sheet(proyectosData.length ? proyectosData : [{ Proyecto: "" }]),
      "Proyectos"
    );

    XLSX.writeFile(wb, "plantillaControlesInventario.xlsx");
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true });
    if (
      e.file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      this.setState({
        archivosExcel: [{ ...e.file, name: e.file.name, status: "uploading" }],
      });
      this.cargarArchivoExcel(e.file);
    } else {
      message.error("El archivo debe ser un archivo de excel (.xlsx)");
      this.setState({ loading: false });
    }
  }

  cargarArchivoExcel(file) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const hoja1 = XLSX.utils.sheet_to_row_object_array(
        workbook.Sheets[workbook.SheetNames[0]]
      );
      const resultado = this.verificarFilas(hoja1);
      this.setState({
        archivosExcel: [{ ...file, name: file.name, status: "success" }],
        data: resultado.filas,
        archivoError: resultado.errores > 0 ? resultado.archivoErrores : null,
        loading: false,
      });
      if (resultado.errores > 0) {
        message.error(`Se detectaron ${resultado.errores} errores`);
        const validas = resultado.filas.filter((f) => f._valido).length;
        if (validas > 0) {
          message.info(`Se importarán solo las filas correctas: ${validas}`);
        }
      } else {
        message.success("Archivo cargado sin errores");
      }
    };
  }

  verificarFilas(data) {
    let errores = 0;
    const arrayErrores = [];

    const filas = data.map((row) => {
      const fila = row["__rowNum__"] + 1;
      let mensajeErrores = null;

      const clave = row["Clave"] ? `${row["Clave"]}`.trim() : undefined;
      const descripcion = row["Descripcion"]
        ? `${row["Descripcion"]}`.trim()
        : undefined;
      const proyectoNombre = row["Proyecto"]
        ? `${row["Proyecto"]}`.trim()
        : undefined;
      const min =
        row["Min"] !== undefined && row["Min"] !== ""
          ? Number(row["Min"])
          : undefined;
      const max =
        row["Max"] !== undefined && row["Max"] !== ""
          ? Number(row["Max"])
          : undefined;

      const error = (msg) => {
        errores++;
        mensajeErrores = mensajeErrores
          ? mensajeErrores + "; " + msg
          : msg;
      };

      // Buscar insumo por clave o por descripción
      let insumo = null;
      if (clave) {
        insumo = this.state.todasInsumos.find(
          (i) => String(i.clave).trim().toLowerCase() === clave.toLowerCase()
        );
      }
      if (!insumo && descripcion) {
        insumo = this.state.todasInsumos.find(
          (i) =>
            String(i.descripcion).trim().toLowerCase() === descripcion.toLowerCase()
        );
      }
      if (!insumo) {
        error("Insumo no encontrado (verifique Clave o Descripcion)");
      }

      if (min === undefined || isNaN(min)) {
        error("Min es requerido y debe ser un número");
      }

      if (max === undefined || isNaN(max)) {
        error("Max es requerido y debe ser un número");
      } else if (min !== undefined && !isNaN(min) && max <= min) {
        error("Max debe ser mayor que Min");
      }

      // Proyecto es opcional
      let proyecto = null;
      if (proyectoNombre) {
        proyecto = this.state.todasProyectos.find(
          (p) =>
            String(p.nombre).trim().toLowerCase() === proyectoNombre.toLowerCase()
        );
        if (!proyecto) {
          error("Proyecto no encontrado");
        }
      }

      const valido = !mensajeErrores;
      if (!valido) {
        arrayErrores.push({
          Errores: mensajeErrores,
          "Fila archivo inicial": fila,
          ...row,
        });
      }

      return {
        _valido: valido,
        _error: mensajeErrores,
        clave: insumo ? insumo.clave : clave,
        descripcion: insumo ? insumo.descripcion : descripcion,
        proyecto: proyecto ? proyecto.nombre : proyectoNombre,
        min,
        max,
        insumoId: insumo ? insumo._id : undefined,
        proyectoId: proyecto ? proyecto._id : undefined,
      };
    });

    const archivoEditar = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      archivoEditar,
      XLSX.utils.json_to_sheet(arrayErrores),
      "Hoja Errores"
    );
    return { filas, errores, archivoErrores: archivoEditar };
  }

  descargarArchivoErrores() {
    const wbout = XLSX.write(this.state.archivoError, {
      bookType: "xlsx",
      type: "binary",
    });
    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    a.href = window.URL.createObjectURL(blob);
    a.download = "erroresControles.xlsx";
    a.click();
    window.URL.revokeObjectURL(a.href);
  }

  onFinish() {
    const validos = this.state.data.filter((f) => f._valido);
    if (validos.length === 0) {
      return message.warning("No hay filas válidas para importar");
    }
    this.setState({ loading: true });
    const controles = validos.map((f) => ({
      insumoId: f.insumoId,
      proyectoId: f.proyectoId || null,
      min: f.min,
      max: f.max,
    }));
    axios
      .post(
        "controlInventario/importarControles",
        { empresaId: this.props.empresaId, controles },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(`Se importaron ${res.data.numero} controles`);
          if (res.data.repetidos) {
            message.warning(
              `${res.data.repetidos} controles ya existían y no se duplicaron`
            );
          }
          this.atras();
        } else if (res.data.success === 1) {
          message.error(
            res.data.message || "No se pudieron importar los controles"
          );
        } else {
          message.error("Hubo un error y los controles no se importaron");
        }
      });
  }

  render() {
    const validCount = this.state.data.filter((f) => f._valido).length;

    const columns = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        width: 120,
        buscar: "clave",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        width: 280,
        buscar: "descripcion",
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        width: 160,
        render: (v) => v || <span style={{ color: "#bbb" }}>Sin proyecto</span>,
      },
      {
        title: "Min",
        dataIndex: "min",
        key: "min",
        width: 80,
      },
      {
        title: "Max",
        dataIndex: "max",
        key: "max",
        width: 80,
      },
      {
        title: "Estado",
        key: "estado",
        width: 120,
        render: (_, record) =>
          record._valido ? (
            <Tag color="green">OK</Tag>
          ) : (
            <Tooltip title={record._error}>
              <Tag color="red" style={{ cursor: "help" }}>
                Error
              </Tag>
            </Tooltip>
          ),
      },
    ];

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Importar Controles de Inventario"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            this.state.archivoError ? (
              <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>
                Descargar Errores
              </ButtonItem>
            ) : null
          }
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando, espere por favor">
            <Form
              ref={this.formRef}
              name="importarControlesInventario"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                  disabled={validCount === 0}
                >
                  {validCount > 0
                    ? `Importar (${validCount} controles)`
                    : "Importar"}
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
            >
              <Row style={{ marginTop: 20 }}>
                <Col
                  span={12}
                  xs={24}
                  sm={24}
                  lg={12}
                  xl={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <ButtonItem
                    onClick={() => this.descargarPlantilla()}
                    type="primary"
                  >
                    Descargar Plantilla
                  </ButtonItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem name="archivo" label="Archivo">
                    <Upload
                      showUploadList={{
                        showRemoveIcon: false,
                        showPreviewIcon: false,
                      }}
                      fileList={this.state.archivosExcel}
                      customRequest={this.onChangeArchivo.bind(this)}
                      accept=".xlsx"
                    >
                      <ButtonItem icon={<UploadOutlined />}>Subir</ButtonItem>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
            </Form>
            <TableItem
              size="small"
              dataSource={this.state.data}
              columns={columns}
              rowClassName={(record) => (record._valido ? "" : "row-error")}
            />
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ImportarControlInventario);
